import {AppApi} from 'store/customer/api';

export interface CustomerBranding {
    logo?: string;
    uploadedLogo?: File;
    remove_logo?: boolean;
    primary_colour: string;
    secondary_colour: string;
    primary_icon_colour: string;
    secondary_icon_colour: string;
    header_colour: string;
    header_icon_colour: string;
    header_navigation_text_colour: string;
    navigation_text_colour: string;
}

const CustomerBrandingApi = AppApi.injectEndpoints({
    endpoints: (builder) => ({
        getCustomerBranding: builder.query<CustomerBranding, void>({
            query: () => 'customer-brandings',
            providesTags: ['CustomerBranding'],
            transformResponse: (response: {
                customer_branding: CustomerBranding;
            }) => response.customer_branding,
        }),
        saveCustomerBranding: builder.mutation<void, CustomerBranding>({
            query: (request) => {
                const formData = new FormData();
                const hasLogo = !!request.uploadedLogo;
                if (hasLogo) {
                    formData.append('logo', request.uploadedLogo ?? '');
                    Object.entries(request).forEach(([key, value]) => {
                        if (key === 'uploadedLogo') return;
                        formData.append(key, value as string);
                    });
                }
                return {
                    url: 'customer-brandings',
                    method: 'POST',
                    body: hasLogo ? formData : request,
                };
            },
            invalidatesTags: ['Branding', 'CustomerBranding', 'User'],
        }),
        resetCustomerBranding: builder.mutation<void, void>({
            query: () => {
                return {
                    url: 'customer-brandings',
                    method: 'DELETE',
                };
            },
            invalidatesTags: ['Branding', 'CustomerBranding', 'User'],
        }),
    }),
});

export const {
    useGetCustomerBrandingQuery,
    useLazyGetCustomerBrandingQuery,
    useSaveCustomerBrandingMutation,
    useResetCustomerBrandingMutation,
} = CustomerBrandingApi;
